import React, { Component } from 'react';
import styles from './FJHandle.module.less';
import FJUtil from '../../../util/FJUtil';

class FJHandle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMouseIn: false,
            isDrag: false,
        };

        // 在拖动开始时记录当前的坐标
        // 用于计算拖动的偏差
        this.recordPoint = null;
    }

    componentWillUnmount() {
        this._onDragStart = null;
        this._onDragEnd = null;
        FJUtil.removeEvent(document, 'mousemove', this._onBodyMouseMove);
        FJUtil.removeEvent(document, 'mouseup', this._onBodyMouseUp);
    }

    /**
     * @description 计算两点之间的差值
     * @param {Object} oldPoint
     * @param {number} oldPoint.x
     * @param {number} oldPoint.y
     * @param {Object} newPoint
     * @param {number} newPoint.x
     * @param {number} newPoint.y
     * @return {{x: number, y: number}}
     */
    calcPointOffset = (oldPoint, newPoint) => {
        return {
            x: newPoint.x - oldPoint.x,
            y: newPoint.y - oldPoint.y,
        };
    };

    onMouseDown = e => {
        this._mouseDownNum = e.button;
        if (e.button !== 0 && e.button !== 2) return;

        // 阻断鼠标右键点击冒泡防止场景选中被取消
        if (e.button === 2) {
            e.stopPropagation();
        }
        if (this.props.stopMouseMown) {
            e.stopPropagation();
        }
        if (this.props.onMouseDown) {
            this.props.onMouseDown(e);
        }
        FJUtil.addEvent(document, 'mousemove', this._onBodyMouseMove);
        FJUtil.addEvent(document, 'mouseup', this._onBodyMouseUp);
    };

    _onBodyMouseMove = e => {
        if (this._mouseDownNum === 2) {
            return;
        }
        if (this.state.isDrag) {
            this.onDrag(e);
        } else {
            this.setState({ isDrag: true }, () => {
                if (this._onDragStart) this._onDragStart(e);
            });
        }
    };

    _onBodyMouseUp = e => {
        if (this.state.isDrag) {
            this.setState({ isDrag: false }, () => {
                if (this._onDragEnd) this._onDragEnd(e);
            });
        }
        FJUtil.removeEvent(document, 'mousemove', this._onBodyMouseMove);
        FJUtil.removeEvent(document, 'mouseup', this._onBodyMouseUp);
    };

    _onDragStart = e => {
        this.recordPoint = {
            x: e.clientX,
            y: e.clientY,
        };
        if (this.props.onDragStart) {
            this.props.onDragStart(e, { x: 0, y: 0 });
        }
    };

    onDrag = e => {
        if (this.props.onDrag) {
            const p = { x: e.clientX, y: e.clientY };
            this.props.onDrag(e, this.calcPointOffset(this.recordPoint, p));
        }
    };

    _onDragEnd = e => {
        if (this.props.onDragEnd) {
            const p = { x: e.clientX, y: e.clientY };
            this.props.onDragEnd(e, this.calcPointOffset(this.recordPoint, p));
        }
    };

    onMouseEnter = e => {
        let nativeEvent = e.nativeEvent;
        this.setState(
            {
                isMouseIn: true,
            },
            () => {
                if (this.props.onMouseEnter) {
                    this.props.onMouseEnter(nativeEvent);
                }
            },
        );
    };

    onMouseLeave = e => {
        let nativeEvent = e.nativeEvent;
        this.setState(
            {
                isMouseIn: false,
            },
            () => {
                if (this.props.onMouseLeave) {
                    this.props.onMouseLeave(nativeEvent);
                }
            },
        );
    };

    onMouseUp = e => {
        let nativeEvent = e.nativeEvent;
        if (this.props.onMouseUp) {
            this.props.onMouseUp(nativeEvent);
        }
    };

    onMouseMove = e => {
        let nativeEvent = e.nativeEvent;
        if (this.props.onMouseMove) {
            this.props.onMouseMove(nativeEvent);
        }
    };

    onClick = e => {
        if (this.props.onClick) {
            this.props.onClick(e);
        }
    };

    onContextMenu = e => {
        if (this.props.onContextMenu) {
            this.props.onContextMenu(e);
        }
    };

    onDoubleClick = () => {
        if (this.props.onDoubleClick) {
            this.props.onDoubleClick();
        }
    };

    render() {
        let { style } = this.props;
        return (
            <div
                className={styles.container}
                style={style}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
                onMouseDown={this.onMouseDown}
                onMouseUp={this.onMouseUp}
                onMouseMove={this.onMouseMove}
                onClick={this.onClick}
                onContextMenu={this.onContextMenu}
                onDoubleClick={this.onDoubleClick}
            >
                {this.props.render ? this.props.render(this.state) : null}
                {this.props.children}
            </div>
        );
    }
}

export default FJHandle;
